import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useBlogsList() {
  // Use toast
  const toast = useToast();

  const refBlogListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "blog_date", label: "通告日期", sortable: true },
    { key: "title", label: "通告標題", sortable: true },
    { key: "show_details", label: "顯示全部 ", sortable: true },
    // { key: "content", label: "通告內容"},
    { key: "created_at", label: "發佈時間"},
    { key: "is_active", label: "狀態"},
    { key: "show_in_marquee", label: "走馬燈顯示"},
    { key: "actions", label: "操作", class: 'sticky-column' },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const blogsList = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refBlogListTable.value
      ? refBlogListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refBlogListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchBlogs = (ctx, callback) => {
    
    store
      .dispatch("blog/fetchBlogs", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { blogs, total } = response.data;
        callback(blogs);
        totalRow.value = total;
        blogsList.value = blogs
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };


  return {
    fetchBlogs,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    blogsList,
    refBlogListTable,
    ability,
    refetchData,
  };
}
